module.exports = __webpack_public_path__ + "img/EQULIZER.687cb846.svg";